import { render } from "./MainLayoutPage.vue?vue&type=template&id=2c597f72"
import script from "./MainLayoutPage.vue?vue&type=script&lang=js"
export * from "./MainLayoutPage.vue?vue&type=script&lang=js"

import "./MainLayoutPage.vue?vue&type=style&index=0&id=2c597f72&lang=css"

import exportComponent from "/Users/kaho/cloudfit-pro-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__